export function data() {
  return {
    isDebug: true,
    isOpen: false,
    loading: true,
    isFetching: false,
    openOnFocus: true,
    buttonText: 'Add',
    file: null,
    base64pdf: '',
    scale: 1,
    imageContent: null,
    description: '',
    title: 'Create',
    attachment: false,
    profileImageDocumentID: 0,
    pageCount: []
  }
}
